// src/components/OwnerSelect.tsx
import Select from "react-select";
import { withValidate } from "./withValidate";

interface SelectListOption {
  value: string;
  label: string;
}

interface SelectListProps {
  onChange: (value: SelectListOption | null) => void;
  options: SelectListOption[];
  placeholder?: string;
  isSearchable?: boolean;
  style?: React.CSSProperties;
  isDefaultValue?: boolean;
  defaultValues?: SelectListOption;
  value?: SelectListOption | null;
  boxHeight?: number;
  editable?: boolean;
}

export default function SelectList({
  onChange,
  options,
  placeholder = "선택하세요",
  isSearchable = true,
  style,
  isDefaultValue = false,
  defaultValues,
  value,
  boxHeight = 40,
  editable = true,
}: SelectListProps) {
  return (
    <Select
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      classNamePrefix="react-select"
      menuPortalTarget={typeof window !== "undefined" ? document.body : null}
      // 메뉴 열 때 페이지를 스크롤해 메뉴를 보이게 하는 기본동작 OFF
      //   → 선택 후 sticky 헤더가 위로 밀려 올라가던 현상 방지(포탈이라 스크롤 불필요)
      menuShouldScrollIntoView={false}
      //   menuPosition="fixed"
      value={value}
      defaultValue={isDefaultValue ? defaultValues || options[0] : null}
      isSearchable={isSearchable}
      isDisabled={!editable}
      styles={{
        // body로 포탈되는 메뉴가 sticky 헤더/nav 등에 가려지지 않도록 z-index 명시
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
        control: (base, state) => ({
          ...base,
          minHeight: `${boxHeight}px`,
          borderRadius: "0.5rem",
          fontSize: "0.95rem",
          borderColor: state.isFocused ? "#cccccc" : "#cccccc",
          boxShadow: state.isFocused ? "0 0 0 2px #FF9934" : "none",
          "&:hover": {
            border: "1px solid #cccccc",
          },
          "&:focus": {
            border: "1px solid #cccccc",
          },
          ...style,
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected
            ? "#FFC286" // 선택된 옵션
            : state.isFocused
              ? "#FF9934 " // hover
              : "white",
          color: state.isSelected || state.isFocused ? "white" : "black",
          cursor: "pointer",
          // 아래 추가: active 상태도 커스텀
          ":active": {
            backgroundColor: "#FF9934", // 클릭 시에도 주황색
            color: "white",
          },
        }),
      }}
    />
  );
}
export const ValidateSelectList = withValidate(SelectList);
